"use client";

import { IconBrain, IconChartBar, IconKey } from "@tabler/icons-react";
import Link from "next/link";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

const items = [
  {
    href: "/deploy/keys",
    title: "Manage API keys",
    description: "Create and manage your API keys for authentication.",
    Icon: IconKey,
  },
  {
    href: "/deploy/models",
    title: "Explore models",
    description: "Compare models to find the right fit for your workload.",
    Icon: IconBrain,
  },
  {
    href: "/analytics",
    title: "View usage",
    description: "Track your API usage, costs, and token consumption.",
    Icon: IconChartBar,
  },
] as const;

export const DashboardGetStarted = () => (
  <div className="grid gap-4 px-4 md:grid-cols-3 lg:px-6">
    {items.map(({ href, title, description, Icon }) => (
      <Link
        key={href}
        href={href}
        className={cn(
          "block rounded-xl outline-none transition-colors",
          "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        )}
      >
        <Card className="h-full cursor-pointer hover:bg-muted/30">
          <CardHeader>
            <div className="mb-2 flex size-9 items-center justify-center rounded-md border bg-sidebar">
              <Icon className="size-5 text-muted-foreground" aria-hidden />
            </div>
            <CardTitle className="text-base">{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </CardHeader>
        </Card>
      </Link>
    ))}
  </div>
);
